import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subscription } from '../../types/Subscription';
import { SubscriptionAccess } from '../../types/Subscription';

interface SubscriptionState {
  subscription: Subscription | null;
}

const initialState: SubscriptionState = {
  subscription: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    /**
     * Stores the subscription status response from the backend.
     */
    setSubscription: (state, action: PayloadAction<Subscription>) => {
      state.subscription = action.payload;
    },
    /**
     * Clears the subscription data (for example on logout).
     */
    clearSubscription: (state) => {
      state.subscription = null;
    },
  },
});

export const { setSubscription, clearSubscription } = subscriptionSlice.actions;

export const selectSubscription = (state: {
  subscription: SubscriptionState;
}) => state.subscription.subscription;

// Selectors
export const selectAccessLevel = (state: { subscription: SubscriptionState }) =>
  state.subscription.subscription?.accessLevel ?? SubscriptionAccess.FREE;

/**
 * Whether the user can still start the one-time free trial. Drives whether
 * upgrade CTAs read "Start Free Trial" (eligible) or "Upgrade" (ineligible).
 * Defaults to `false` when the backend hasn't supplied the flag. The slice is
 * optional-chained so components that consume this (e.g. the always-mounted
 * UpgradeModal) render safely in isolated tests whose store omits the slice.
 */
export const selectIsTrialEligible = (state: {
  subscription?: SubscriptionState;
}) => state.subscription?.subscription?.isEligibleForTrial ?? false;

export default subscriptionSlice.reducer;
